// Entry point for the build script in your package.json
import "core-js/stable";

import "@hotwired/turbo-rails";

import "./src/account_menu";
import "./src/disabling_checkbox";
import "./src/navigation_menu";
import "./src/reset_password_link";

import { I18n } from "i18n-js";
import translations from "./locales.json";
window.i18n = new I18n(translations);

import "trix";
import "@rails/actiontext";

import "./components/mount";
